import {
  Grid,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import RegularButton from "components/CustomButtons/Button";
import { resetOnClick } from "helpers/resetOnClick";
import { validateObject } from "helpers/validateObject";
import { useToggle } from "hooks/useToggle";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  editSettlementLTS,
  editSettlementEndRouteEndowment,
  editSettlementPercentage,
} from "redux/actions/routesStatus/routesStatusAction";
import { KgsBulkForm } from "./KgsBulkForm";
import { formatNumber } from "helpers/getNumberFormats";

export const CameBackWith = ({ block = false, disabled }) => {
  const dispatch = useDispatch();
  const { settlement } = useSelector((state) => state.routesStatus);
  const { routes, unit, kgBulk } = validateObject(settlement) && settlement;
  const { start, end } = validateObject(routes) && routes;

  const {
    rotogauge: startRotogauge,
    flowmeter: startFlowmeter,
  } = start.endowments;

  const { cil10, cil20, cil30, cil45, rotogauge, flowmeter } = end.endowments;

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [openBulk, setOpenBulk] = useToggle();
  const handleEndEndowments = ({ target }, isBulk) => {
    const value = target.value == "" ? 0 : parseFloat(target.value);
    if (isNaN(value)) return;

    dispatch(
      editSettlementEndRouteEndowment(
        target.name,
        value < 0 ? 0 : value,
        isBulk,
      ),
    );
  };

  const handleInitEndowments = ({ target }) => {
    const value = target.value == "" ? 0 : parseFloat(target.value);
    if (isNaN(value)) return;
    dispatch(
      editSettlementEndRouteEndowment(target.name, value < 0 ? 0 : value),
    );
  };

  const handleEndowmentsLts = ({ target }, routeType) => {
    const { value, name } = target;
    const regex = /^\d*(\.\d{0,2})?$/;
    if (regex.test(value) || value === "") {
      const numericValue = value === "" ? 0 : value;
      dispatch(
        editSettlementLTS(name, numericValue < 0 ? 0 : numericValue, routeType),
      );
    }
  };

  const handlePercentage = ({ target }, routeType) => {
    const { value, name } = target;
    const regex = /^\d*(\.\d{0,2})?$/;
    if (routeType && (regex.test(value) || value === "")) {
      const numericValue = value === "" ? 0 : value;
      dispatch(
        editSettlementPercentage(
          name,
          numericValue < 0 ? 0 : numericValue,
          routeType,
        ),
      );
    }
  };

  return (
    <>
      {!block ? (
        <>
          {!settlement?.unit.type.toLowerCase().includes("estacion") &&
          isMobile ? (
            <Grid item xs={12} sm={6}>
              <Typography
                variant="body1"
                color="primary"
                component="h3"
                style={{ marginBottom: 15 }}
              >
                Regreso con:
              </Typography>
            </Grid>
          ) : null}

          <Grid
            container
            spacing={1}
            style={{
              paddingLeft: 4,
              paddingRight: 5,
              marginTop: 0,
              position: "relative",
              display: "flex",
              alignItems: "center",
            }}
          >
            <RegularButton
              color="transparent"
              style={{
                position: "absolute",
                top: -45,
                right: 10,
              }}
              onClick={setOpenBulk}
            >
              Kgs a Granel: {formatNumber({ input: kgBulk || 0 })} Kgs
            </RegularButton>
            {openBulk && (
              <KgsBulkForm
                open={openBulk}
                onClose={setOpenBulk}
                disabled={disabled}
                handleEndEndowments={handleEndEndowments}
                kgBulk={kgBulk}
                resetOnClick={resetOnClick}
              />
            )}
            <Grid item xs={12} sm={12} md={3}>
              <TextField
                label="De 10:"
                margin="dense"
                variant="outlined"
                fullWidth
                name="cil10"
                value={cil10}
                disabled={disabled}
                onChange={handleEndEndowments}
                InputProps={{ inputProps: { min: 0, right: "1" } }}
                error={start.endowments.cil10 < cil10}
                helperText={
                  start.endowments.cil10 < cil10
                    ? "El regreso no puede ser mayor"
                    : ""
                }
                onFocus={() =>
                  resetOnClick(handleEndEndowments, cil10, "cil10")
                }
              />
            </Grid>{" "}
            <Grid item xs={12} sm={12} md={3}>
              <TextField
                label="De 20:"
                margin="dense"
                variant="outlined"
                fullWidth
                name="cil20"
                value={cil20}
                disabled={disabled}
                onChange={handleEndEndowments}
                InputProps={{ inputProps: { min: 0, right: "1" } }}
                error={start.endowments.cil20 < cil20}
                helperText={
                  start.endowments.cil20 < cil20
                    ? "El regreso no puede ser mayor"
                    : ""
                }
                onFocus={() =>
                  resetOnClick(handleEndEndowments, cil20, "cil20")
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3}>
              <TextField
                label="De 30:"
                margin="dense"
                variant="outlined"
                fullWidth
                name="cil30"
                value={cil30}
                disabled={disabled}
                onChange={(e) => handleEndEndowments(e)}
                InputProps={{ inputProps: { min: 0, right: "1" } }}
                error={start.endowments.cil30 < cil30}
                helperText={
                  start.endowments.cil30 < cil30
                    ? "El regreso no puede ser mayor"
                    : ""
                }
                onFocus={() =>
                  resetOnClick(handleEndEndowments, cil30, "cil30")
                }
              />
            </Grid>
            <Grid item xs={12} sm={12} md={3}>
              <TextField
                label="De 45:"
                margin="dense"
                variant="outlined"
                fullWidth
                // type="number"
                name="cil45"
                value={cil45}
                disabled={disabled}
                onChange={handleEndEndowments}
                InputProps={{ inputProps: { min: 0, right: "1" } }}
                error={start.endowments.cil45 < cil45}
                helperText={
                  start.endowments.cil45 < cil45
                    ? "El regreso no puede ser mayor"
                    : ""
                }
                onFocus={() =>
                  resetOnClick(handleEndEndowments, cil45, "cil45")
                }
              />
            </Grid>
          </Grid>
        </>
      ) : (
        <>
          {unit?.type.includes("ESTACION") && (
            <>
              {unit?.type === "ESTACION" && (
                <Grid item xs={12} md={2}>
                  <TextField
                    label="Dispensario"
                    margin="dense"
                    variant="outlined"
                    fullWidth
                    name="dispenser"
                    value={settlement?.dispenser?.name}
                    disabled
                    InputProps={{ inputProps: { min: 0, right: "1" } }}
                  />
                </Grid>
              )}
              <Grid item xs={12} md={2}>
                <TextField
                  label="Cuenta Lts Inicial"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  name="flowmeter"
                  value={startFlowmeter}
                  disabled
                  onChange={handleInitEndowments}
                  inputProps={{
                    min: 0,
                    right: "1",
                  }}
                  onFocus={() =>
                    resetOnClick(
                      handleEndEndowments,
                      startFlowmeter,
                      "flowmeter",
                    )
                  }
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  label="Cuenta Lts Final"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  // type="number"
                  name="flowmeter"
                  value={flowmeter}
                  disabled={disabled}
                  onChange={(e) => handleEndowmentsLts(e, "end")}
                  inputProps={{
                    min: 0,
                    right: "1",
                  }}
                  onFocus={() =>
                    resetOnClick(handleEndEndowments, flowmeter, "flowmeter")
                  }
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <TextField
                  label="Lts Totales a Reportar"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  // type="number"
                  name="totalReport"
                  value={
                    settlement?.totalReport < 0 ? 0 : settlement?.totalReport
                  }
                  disabled
                  InputProps={{
                    inputProps: { min: 0, right: "1" },
                  }}
                />
              </Grid>
              <Grid item xs={12} md={unit.type === "ESTACION" ? 1 : 2}>
                <TextField
                  label="% Inicial:"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  // type="number"
                  name="rotogauge"
                  value={startRotogauge}
                  disabled={disabled}
                  onChange={(e) => handlePercentage(e, "start")}
                  inputProps={{
                    min: 0,
                    right: "1",
                    step: 0.5,
                  }}
                  onFocus={() =>
                    resetOnClick(handlePercentage, startRotogauge, "rotogauge")
                  }
                />
              </Grid>
              <Grid item xs={12} md={unit.type === "ESTACION" ? 1 : 2}>
                <TextField
                  label="% Final:"
                  margin="dense"
                  variant="outlined"
                  fullWidth
                  name="rotogauge"
                  value={rotogauge}
                  disabled={disabled}
                  onChange={(e) => handlePercentage(e, "end")}
                  inputProps={{
                    min: 0,
                    right: "1",
                    step: 0.5,
                  }}
                  helperText={
                    rotogauge > startRotogauge
                      ? "El % Final no puede ser Mayor al % Inicial"
                      : ""
                  }
                  onFocus={() =>
                    resetOnClick(handlePercentage, rotogauge, "rotogauge")
                  }
                />
              </Grid>
            </>
          )}
        </>
      )}
    </>
  );
};
